<mat-progress-bar
  *ngIf="progressBarService.progressBarVisible$ | async"
  mode="indeterminate"
  color="primary">
</mat-progress-bar>
<router-outlet></router-outlet>
